<!--
    描述：项目管理 --劳务通项目- 招募基本信息
    日期：2022-7-27
    Created by 李家宝
-->
<template>
  <div class="juyi-project-msg-main">
    <!-- :class="[ audit === 'view'? 'expert-overflow' :'' ]" -->
    <div class="expert-content">
      <el-form
        :model="laowuProjectMsg"
        label-width="170px"
        size="small"
        ref="personForm"
        :show-message="false"
      >
        <el-row class="mb20">
          <el-col :span="24">
            <h3>{{ laowuProjectMsg.sname }}</h3>
          </el-col>
        </el-row>

        <el-row style="">
          <el-col :span="24">

            <el-form-item>
              <span slot="label">
                <span class="blacktext">当前状态：</span>
              </span>
              <div class="bluetext">{{ currentState }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招募方：">
              {{ laowuProjectMsg.publishName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布时间：">
              {{ laowuProjectMsg.sendTime }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招募类型：">
              {{ laowuProjectMsg.recruitTypeName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招募地区：">
              {{
                laowuProjectMsg.projectProvinceName +
                laowuProjectMsg.projectCityName
              }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招募截止时间：">
              <span class="redtext">{{ laowuProjectMsg.endDate }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招募方联系人：">
              {{ laowuProjectMsg.linkMan }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式：">
              {{ laowuProjectMsg.linkPhone }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招募对象要求：">
              {{ laowuProjectMsg.recruitRequirementName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="招募人数：">
              <span class="bluetext">
                {{ laowuProjectMsg.recruitNumber }}
              </span>
              人
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="招募详情：">
              <p
                style="
                  width: 64%;
                  font-size: 14px;
                  font-family: Avenir, Helvetica, Arial, sans-serif;
                  white-space: pre-wrap;
                  word-break: break-all;
                "
              >
                {{ laowuProjectMsg.recruitDetail }}
              </p>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="福利待遇：">
              <div v-if="laowuProjectMsg.welfareArr.length > 0">
                <el-tag
                  v-for="(item, index) in laowuProjectMsg.welfareArr"
                  class="fuliitembox"
                  :key="'fuli' + index"
                  >{{ item }}
                </el-tag>
              </div>

              <div v-else>无</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上传附件资料：">
              <div class="beyondHiding">
                  <div
                      v-for="(item, index) in laowuProjectMsg.sysFiles"
                      :key="index"
                      class="link mr10"
                      type="text"
                      @click="viewFile(item.fileDirectory + item.serverName, item.fileName)"
                  >
                    <span slot="reference">{{ item.fileName }}</span>
<!--                    <el-popover
                        placement="top-start"
                        title="文件"
                        trigger="hover"
                    >
                      <div
                          v-for="e in laowuProjectMsg.sysFiles"
                          class="link"
                          :key="e.id"
                          @click="viewFile(e.fullFilePath)"
                      >
                        {{ e.fileName }}
                      </div>
                      <span slot="reference">{{ item.fileName }}</span>
                    </el-popover>-->
                  </div>
              </div>
<!--              <my-upload
                ref="cns"
                :aid="laowuProjectMsg.id"
                :maxNum="1"
                :tableName="'business_expand_laowu'"
                mode="view"
                forDatabase="project_audit"
                :isDisabled="true"
              >
              </my-upload>-->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="工种要求：">
              <el-table
                :data="laowuProjectMsg.jobDetailsArr"
                highlight-current-row
                row-key="id"
                border
                ref="table"
              >
                <el-table-column
                  prop="positonName"
                  label="招募工种"
                  align="center"
                  header-align="center"
                  min-width="150"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="workNature"
                  label="工作性质"
                  align="center"
                  header-align="center"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span>{{
                      scope.row.workNature == 1 ? "全职" : "兼职"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="recruitNum"
                  label="招募人数"
                  header-align="center"
                  align="center"
                  min-width="140"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="genderRequireText"
                  label="性别要求"
                  header-align="center"
                  align="center"
                  min-width="140"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="workingYearsText"
                  label="工作年限要求"
                  header-align="center"
                  min-width="140"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="ageRequireText"
                  label="年龄要求"
                  align="center"
                  header-align="center"
                  min-width="140"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="salarySettlementText"
                  label="薪资结算"
                  align="center"
                  width="110"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="remuneration"
                  label="薪资待遇"
                  align="center"
                  width="110"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="remark"
                  label="工程量备注"
                  header-align="center"
                  align="center"
                  min-width="140"
                  show-overflow-tooltip
                ></el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- <img
        v-if="rowData.registrationDeadlineType == '已截至'"
        src="../../../../assets/images/recruitingAsOf.png"
        class="img"
      />
      <img v-else src="../../../../assets/images/recruiting.png" class="img" /> -->
    </div>
    <div class="pdl10 pdr10" v-if="audit === 'view'">
      <h3>审核记录：</h3>
      <el-table
        :data="checkData"
        class="mt15"
        height="200px"
        highlight-current-row
        row-key="id"
        border
        ref="table"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="70"
        ></el-table-column>
        <el-table-column
          label="审核人"
          align="center"
          width="140"
          prop="createUserName"
        ></el-table-column>
        <el-table-column
          label="审核时间"
          align="center"
          width="150"
          prop="createDate"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.createDate ? scope.row.createDate.substring(0, 16) : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作步骤"
          align="center"
          width="120"
          prop="currentSteps"
        ></el-table-column>
        <el-table-column label="审核结果" header-align="center" prop="content">
        </el-table-column>
      </el-table>
    </div>
    <div class="footer text-right">
      <el-button
        size="mini"
        icon="el-icon-edit-outline"
        v-if="audit === 'audit'"
        @click="auditSubmit"
        >审核
      </el-button>
    </div>
  </div>
</template>
<script>
import { laowuselectProjectById,lwtOperation } from "api/modules/projectManagement";
import VUE_CONFIG from "../../../../../vue.config";
export default {
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    audit: {
      type: String,
      default: "",
    },
  },
  filters: {
    dateFilter(time) {
      return bmTooljs.dateformat(new Date(time), "yyyy-MM-dd");
    },
  },
  data() {
    return {
      laowuProjectMsg: {
        id: "",
        baseId: "",
        businessId: "",
        jobDetails: "", //岗位要求
        jobDetailsArr: [], //岗位要求
        welfare: "",
        welfareArr: [], //福利
      },
      currentState: 111, //当前状态（调服务查的）
      checkData: [], //操作记录
    };
  },
  created() {
    if (!this.rowData.id) {
      this.$router.push({
        name: "to-audit-proJect-list",
      });
      return;
    }
    //数据加载
    this.laowuselectProjectById();
     this.lwtOperation() //项目当前状态
  },
  methods: {
    // 审核
    auditSubmit() {
      let params = {
        id: this.laowuProjectMsg.baseId,
      };

      this.$emit("openDia", params);
    },
    //获取劳务通项目
    laowuselectProjectById() {
      laowuselectProjectById({
        id: this.rowData.id,
      }).then((res) => {
        if (res.operationCode == "1") {
          this.laowuProjectMsg = res.data;
          if (res.data.recruitJobRequirement != null) {
            this.laowuProjectMsg.jobDetails = JSON.parse(
              res.data.recruitJobRequirement
            );
            this.laowuProjectMsg.jobDetailsArr =
              this.laowuProjectMsg.jobDetails;
          }

          if (this.laowuProjectMsg.welfare) {
            this.laowuProjectMsg.welfareArr =
              this.laowuProjectMsg.welfare.split(",");
          } else {
            this.laowuProjectMsg.welfareArr = [];
          }
        }
      });
    },
    //获取劳务通当前的状态
      lwtOperation() {
      lwtOperation({
        id: this.rowData.businessId,
      }).then((res) => {
        if (res.operationCode == "1") {
          this.currentState = res.data.recruitStatusText;
        }
      });
    },
    // 查看文件
    viewFile(filePath, fileName) {
      let uploadUrl = "";
      if (process.env.VUE_APP_UPLOAD_URL == "/uploadApi") {
        uploadUrl = VUE_CONFIG.devServer.proxy["/uploadApi"].target;
      } else {
        uploadUrl = process.env.VUE_APP_UPLOAD_URL;
      }
      this.$previewFn(uploadUrl + filePath, fileName)
    },
  },
};
</script>
<style scoped lang="less">
.juyi-project-msg-main {
  height: 100%;

  .expert-content {
    background-color: #fff;
    padding: 20px;
    position: relative;
    .img {
      position: absolute;
      top: 50px;
      right: 165px;
      width: 143px;
      height: 111px;
    }
  }
}

.redtext {
  color: #ff0000;
}

.footer {
  position: absolute;
  top: 88px;
  right: 135px;

  .el-button {
    height: 28px !important;
  }
}

.fuliitembox {
  width: 90px;
  text-align: center;
  margin-right: 10px;
  margin-bottom: 10px;
}
.bluetext {
  color: #0000ff;
   font-weight: 600;
}
.blacktext {
  color: #000;
  font-weight: 600;
}
</style>
